import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import { ArrayUtils } from "source/app/services/ArrayUtils";
import { ReadState } from "source/app/services/UI/State/ReadState";
import { SetState } from "source/app/services/UI/State/SetState";
import { IRenderChildNodesState } from "../IRenderChildNodesState";
import { IsToday } from "source/app/services/Time/Time";

export function LocalDeleteMultipleNodesForOutdatedTasks(
    nodesToDelete: IWorkflowNode[]
) {
    const renderChildNodes = ReadState<IRenderChildNodesState>(
        ESharedFunction.RenderChildNodes_state
    )!;

    let immediateChildren = [...renderChildNodes.immediateChildren];
    let sortedNodes = [...renderChildNodes.sortedNodes];

    nodesToDelete.forEach((node) => {
        immediateChildren;
        ArrayUtils.Exclude(immediateChildren, node);

        sortedNodes = ArrayUtils.Exclude(sortedNodes, node);
    });

    SetState<IRenderChildNodesState>(ESharedFunction.RenderChildNodes_state, {
        immediateChildren,
        sortedNodes,
    });
}
